import * as R from 'ramda';
import { PTO_DIALOGUE_TYPES } from 'feature/inventory-management/product-transfer-order/utils';
import {
  acceptPtoReset,
  sendAcceptPto,
} from 'feature/inventory-management/product-transfer-order/store/acceptOrder';
import {
  rejectPtoReset,
  sendRejectPto,
} from 'feature/inventory-management/product-transfer-order/store/rejectOrder';
import {
  cancelPtoReset,
  sendCancelPto,
} from 'feature/inventory-management/product-transfer-order/store/cancelOrder';

const actions = (actionType, dispatch) =>
  R.cond([
    [
      R.equals(PTO_DIALOGUE_TYPES.accept),
      () => ({
        action: R.o(dispatch, sendAcceptPto),
        data: R.path(['pto', 'acceptPto']),
        pastTense: 'Accepted',
        reset: () => dispatch(acceptPtoReset()),
      }),
    ],
    [
      R.equals(PTO_DIALOGUE_TYPES.reject),
      () => ({
        action: R.o(dispatch, sendRejectPto),
        data: R.path(['pto', 'rejectPto']),
        pastTense: 'Rejected',
        reset: () => dispatch(rejectPtoReset()),
      }),
    ],
    [
      R.equals(PTO_DIALOGUE_TYPES.cancel),
      () => ({
        action: R.o(dispatch, sendCancelPto),
        data: R.path(['pto', 'cancelPto']),
        pastTense: 'Canceled',
        reset: () => dispatch(cancelPtoReset()),
      }),
    ],
    [
      R.T,
      () => ({
        action: () => {},
        data: () => ({}),
        pastTense: '',
        reset: () => {},
      }),
    ],
  ])(actionType);

export default actions;
